var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hp"},[_c('video',{ref:"video",staticClass:"hp-video",attrs:{"playsinline":"","controls":""},on:{"timeupdate":_vm.onTime,"loadedmetadata":_vm.onMeta}}),(_vm.error)?_c('div',{staticClass:"hp-error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }